import type { UpdateAdvisorResponse } from '../types/updateAdvisor';

const UPDATE_ADVISOR_API_URL = 'https://api.playcdu.co/updateadvisor';

class UpdateAdvisorApiService {
  async getPacks(signal?: AbortSignal): Promise<UpdateAdvisorResponse> {
    const timeout = AbortSignal.timeout(20_000);
    const response = await fetch(UPDATE_ADVISOR_API_URL, { cache: 'no-store', signal: signal ? AbortSignal.any([signal, timeout]) : timeout });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Update Advisor API Error: ${response.status} ${response.statusText} - ${errorText}`);
    }

    return response.json();
  }
}

export const updateAdvisorApiService = new UpdateAdvisorApiService();
